import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../utils/api';
import { BookOpen, Mail, Lock, User, Phone, Globe } from 'lucide-react';
import './Login.css';

const Login = () => {
  const [isSignup, setIsSignup] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    languagePreference: 'english',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (isSignup) {
        const response = await authAPI.signup(formData);
        login(response.data.user, response.data.token);
        navigate('/dashboard');
      } else {
        const response = await authAPI.login({
          email: formData.email,
          password: formData.password,
        });
        login(response.data.user, response.data.token);
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <BookOpen size={48} className="login-icon" />
          <h1>HolyBible365</h1>
          <p>Read the Entire Bible in 365 Days</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          {isSignup && (
            <>
              <div className="input-group">
                <label htmlFor="firstName">
                  <User size={18} /> First Name *
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  placeholder="Enter your first name"
                />
              </div>

              <div className="input-group">
                <label htmlFor="lastName">
                  <User size={18} /> Last Name *
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  placeholder="Enter your last name"
                />
              </div>
            </>
          )}

          <div className="input-group">
            <label htmlFor="email">
              <Mail size={18} /> Email *
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
            />
          </div>

          {isSignup && (
            <div className="input-group">
              <label htmlFor="phone">
                <Phone size={18} /> Phone *
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                placeholder="Enter your phone number"
              />
            </div>
          )}

          <div className="input-group">
            <label htmlFor="password">
              <Lock size={18} /> Password *
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
              minLength="6"
            />
          </div>

          {isSignup && (
            <div className="input-group">
              <label htmlFor="languagePreference">
                <Globe size={18} /> Language Preference
              </label>
              <select
                id="languagePreference"
                name="languagePreference"
                value={formData.languagePreference}
                onChange={handleChange}
              >
                <option value="english">English</option>
                <option value="telugu">Telugu (తెలుగు)</option>
                <option value="both">Both Languages</option>
              </select>
            </div>
          )}

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Please wait...' : isSignup ? 'Create Account' : 'Login'}
          </button>

          {!isSignup && (
            <button type="button" className="forgot-password-btn">
              Forgot password?
            </button>
          )}
        </form>

        <div className="login-footer">
          <p>
            {isSignup ? 'Already have an account?' : "Don't have an account?"}
            <button onClick={() => setIsSignup(!isSignup)} className="toggle-btn">
              {isSignup ? 'Login' : 'Sign Up'}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
